import { t } from "@lingui/macro";
import * as React from "react";
import { Path, Rect } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const BlockSquareIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 12 12"
    color="currentColor"
    title={t`Block Square`}
    {...props}
  >
    <Rect width={12} height={12} fill="currentColor" rx={3} />
    <Path stroke="#fff" strokeLinecap="round" strokeWidth={1.5} d="m3 9 6-6" />
  </Icon>
);
